import http from "@/http-common";

/* eslint-disable */
class StationForSystemDataService {

    getStationCodeForSystem(): Promise<any>{
        return http.api.post("/getStationCodeForSystem/");
    }
    deleteStationCodeForSystem(data : any): Promise<any>{
        return http.api.post("/deleteStationCodeForSystem/", data);
    }
    insertStaionCodeForSystem(data : any): Promise<any>{
        return http.api.post("/insertStaionCodeForSystem/", data);
    }
    updateStaionCodeForSystem(data : any): Promise<any>{
        return http.api.post("/updateStaionCodeForSystem/", data);
    }

}

export default new StationForSystemDataService();
